import { defaultReturn } from '../../../util/newStudent';
import * as api from '../../api/newStudent/apiStudent.service';
import type {
  IMyGardesShow,
  IDisciplineGardesShow,
} from '../../../types/newStudent/myGrades.interface';

export type { ICourses, IMyGardesShow, IGradeActivity, IDisciplineGrades, IDisciplineGardesShow } from '../../../types/newStudent/myGrades.interface';

export const myGradesServiceNewStudent = {
  async show(): Promise<{
    data: IMyGardesShow[];
    message: string[];
    result: boolean;
  }> {
    try {
      const request = await api.authenticatedRequest(
        '/student/my-grades/show',
        'GET',
      );

      return defaultReturn(request);
    } catch (error) {
      throw new Error(error);
    }
  },
  async grades(id: number | string): Promise<{
    data: IDisciplineGardesShow[];
    message: string[];
    result: boolean;
  }> {
    try {
      const request = await api.authenticatedRequest(
        '/student/my-grades/grades',
        'POST',
        { id },
      );

      return defaultReturn(request);
    } catch (error) {
      throw new Error(error);
    }
  },
};
